import { ErrorBoundary } from "components/ErrorBoundary/ErrorBoundary";
import { NavigationStack } from "components/NavigationStack/NavigationStack";
import { IdleLogoutProvider } from "providers/IdleLogoutProvider";
import { InitialLanguageProvider } from "providers/InitialLanguageProvider";
import { KeycloakProvider } from "providers/KeycloakProvider";
import { ServiceWorkerRegistrationProvider } from "providers/ServiceWorkerRegistrationProvider";
import { WizardProvider } from "providers/WizardProvider";
import { Toast } from "./components";
import "react-toastify/dist/ReactToastify.css";
import "styles/fonts.css";

function App() {
  return (
    <>
      <InitialLanguageProvider>
        <ServiceWorkerRegistrationProvider>
          <ErrorBoundary>
            <KeycloakProvider>
              <IdleLogoutProvider 
                timeoutMinutes={15}
                warningMinutes={1}
                crossTab={true}
              >
                <WizardProvider>
                  <NavigationStack />
                  <Toast />
                </WizardProvider>
              </IdleLogoutProvider>
            </KeycloakProvider>
          </ErrorBoundary>
        </ServiceWorkerRegistrationProvider>
      </InitialLanguageProvider>
    </>
  );
}

export default App;
